module.exports = __webpack_public_path__ + "static/media/electrical-design-wiring-plc-panel.7ee42481.jpg";